import styled, { css } from 'styled-components'

export const HiddenRadio = styled.input.attrs({ type: 'radio' })`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`

const checkedStyles = css`
  border-color: ${props => props.theme.colors.primary};
  background-color: ${props => props.theme.colors.primary};
`

const uncheckedStyles = css`
  border-color: ${props => props.theme.colors.grays.N500};
  background-color: ${props => props.theme.colors.white};
`

export const StyledRadio = styled.div`
  margin-right: 8px;

  width: 18px;
  height: 18px;

  border: 2px solid;
  border-radius: 9px;
  box-shadow: inset 0 0 0 2px white;

  transition: all 0.2s;

  ${props => (props.checked ? checkedStyles : uncheckedStyles)}
`
